<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="success"
          dark
          v-bind="attrs"
          v-on="on"
          class="float-left"
          @click.native="verificarVenta"
          :loading="loading"
          v-show="data_venta.value.length != 0 && (!data_venta.pagoEfectivo || (data_venta.ventaValida && data_venta.pagoEfectivo))"
        >
          <v-icon class="mr-2">mdi-cash-check</v-icon>Cobrar
        </v-btn>
      </template>
      <div v-if="!showWarning"></div>
      <v-card v-else>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="cerrarDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Impresion de venta</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn v-show="salida" dark text @click="imprimir">
              <v-icon class="mr-2">mdi-printer</v-icon>Imprimir
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container v-if="!salida">
          <v-row>
            <v-col>
              <v-card>
                <v-card-text>{{ vehiculo.marca }} - {{ vehiculo.vehiculo }}</v-card-text>
                <v-card-text>Fecha de entrada: 01/12/2020</v-card-text>
                <v-card-text>Servicio otorgado: _______</v-card-text>
                <v-card-text>Cliente: Fausto Diaz Ortiz</v-card-text>
                <v-col>
                  <v-file-input
                    counter
                    multiple
                    show-size
                    filled
                    dense
                    prepend-icon="mdi-camera"
                    label="Imagen de salida"
                  ></v-file-input>
                </v-col>
              </v-card>
            </v-col>
            <v-col>
              <v-card class="pa-3">
                Extras realizados
                <br />
                <ul>
                  <li class="pa-2">
                    Cambio de bujía
                    <v-btn x-small color="danger">
                      <v-icon>mdi-minus</v-icon>
                    </v-btn>0
                    <v-btn x-small color="info">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </li>
                  <li class="pa-2">
                    Nitrogeno en llantas
                    <v-btn x-small color="danger">
                      <v-icon>mdi-minus</v-icon>
                    </v-btn>0
                    <v-btn x-small color="info">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </li>
                  <li class="pa-2">
                    Pieza importada
                    <v-btn x-small color="danger">
                      <v-icon>mdi-minus</v-icon>
                    </v-btn>0
                    <v-btn x-small color="info">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </li>
                </ul>
              </v-card>
            </v-col>
            <v-col>
              <v-card class="pa-3">
                <v-list class="ticket">
                  <v-list-item>
                    <b>A cobrar</b>
                  </v-list-item>
                  <ul>
                    <li>
                      Afinacion menor
                      <span class="float-right">$ 499.00</span>
                    </li>
                  </ul>
                  <v-divider></v-divider>
                  <v-list-item-group>
                    <v-text>
                      <b>Total:</b>
                      <span class="float-right">$ 499.00</span>
                    </v-text>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn @click="salida = true" color="success" class="float-right">Registrar salida</v-btn>
            </v-col>
          </v-row>
        </v-container>
        <v-container v-else>
          <TicketVenta :venta="getInfoTicket()"></TicketVenta>
        </v-container>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import ApiService from "../../services/apis";
import Swal from "sweetalert2";
import TicketVenta from "./TicketDeVenta.vue";
import moment from "moment";
export default {
  name: "Venta",
  components: {
    TicketVenta,
  },
  data() {
    return {
      showWarning: false,
      sesion: JSON.parse(sessionStorage.getItem("sesion")),
      dialog: false,
      loading: false,
      salida: true,
      result_venta: {},
      infoTicket: null,
    };
  },
  props: {
    data_venta: {},
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
  computed: {},
  methods: {
    getInfoTicket() {
      let info = {
        sales_details: this.result_venta.sale_detail,
        cliente: this.getName(),
        vehiculo: this.getVehiculo(),
        marca: this.getMarca(),
        fecha: moment(new Date()).format("YYYY/MM/DD"),
        fechaOriginal: false,
        subTotal: this.result_venta?.subtotal?.toFixed(2),
        iva: this.result_venta?.tax?.toFixed(2),
        total: this.result_venta?.total?.toFixed(2),
        folio: this.result_venta.serial_sale,
        concepto: this.data_venta?.concepto ? this.data_venta?.concepto : false,
        cantidadArticulos: this.result_venta.sale_detail?.length,
        nota: this.data_venta.orden.nota_final ? this.data_venta.orden.nota_final : false,
        formaPago: this.data_venta.formaPago,
        cambio: this.data_venta.cambio,
        efectivocapturado: this.data_venta.montoingresado,
        esEfectivo: this.data_venta.pagoEfectivo
      };
      return info;
    },
    save(date) {
      this.$refs.menu.save(date);
    },
    getName() {
      let nameAux = "";
      if (this.data_venta?.orden && this.data_venta.orden?.client) {
        nameAux =
          this.data_venta.orden.client?.name +
          " " +
          this.data_venta.orden.client.first_lastname +
          " " +
          (this.data_venta.orden.client.second_lastname != undefined
            ? this.data_venta.orden.client.second_lastname
            : "");
      } else {
        nameAux = "PUBLICO EN GENERAL";
      }
      return nameAux;
    },
    getVehiculo() {
      let vehiculo = "";
      if (this.data_venta?.orden && this.data_venta.orden?.client) {
        vehiculo =
          this.data_venta.orden.vehicle.model?.name +
          " " +
          this.data_venta.orden.vehicle.year;
      } else {
        vehiculo = "N/A";
      }
      return vehiculo;
    },
    getMarca() {
      let marca = "";
      if (
        this.data_venta?.orden &&
        this.data_venta?.orden?.vehicle?.model.brand?.name
      ) {
        marca = this.data_venta.orden.vehicle.model.brand?.name;
      } else {
        marca = "N/A";
      }
      return marca;
    },
    getFormaPagoD() {
      let formaPago = "";
      if (this.result_venta.payments) {
        formaPago = this.result_venta?.payments[0].paymentType?.name;
      } else {
        formaPago = "Efectivo";
      }
      return formaPago;
    },
    verificarVenta() {
      if (this?.data_venta?.total === 0) {
        Swal.fire({
          title: "Atención!",
          text: "Esta apunto de completar una venta por $0.00, ¿Esta seguro? ",
          icon: "warning",
          showDenyButton: true,
          denyButtonText: `Cancelar`,
          confirmButtonText: "Continuar",
        }).then((result) => {
          if (result.isConfirmed) {
            this.showWarning = true;
            this.registrarVenta();
          } else if (result.isDenied) {
            this.showWarning = false;
            this.data_venta?.orden
              ? this.$router.push("/menu/orden")
              : this.$router.push("/menu/venta");

            location.reload();
          }
        });
      } else {
        this.showWarning = true;
        this.registrarVenta();
      }
    },
    registrarVenta() {
      this.dialog = false;
      // console.log(this.data_venta);
      let detalle_venta = this.data_venta.value.map((x) => {
        if (x.Tipo == "PRODUCTOS") {
          return {
            product: x._id,
            service: null,
            quantity: x.quantity,
            price: x.sale_price,
            type: 1,
          };
        } else {
          return {
            product: null,
            service: x._id,
            quantity: x.quantity,
            price: x.sale_price,
            type: 2,
          };
        }
      });
      let body = {
        order_id: this.data_venta?.orden ? this.data_venta?.orden?._id : null,
        client: this.data_venta?.orden
          ? this.data_venta?.orden?.client?._id
          : this.sesion.employee.branch.general_public_client,
        subtotal: this.data_venta.subtotal,
        tax: this.data_venta.iva,
        total: this.data_venta.total,
        concepto: this.data_venta.concepto,
        payments: [
          {
            total: this.data_venta.total,
            paymentType: this.data_venta.paymentType,
          },
        ],
        sale_date: "",
        user: this.sesion._id,
        sale_detail: detalle_venta,
        employee: this.sesion.employee._id,
        branch: this.sesion.employee.branch._id,
        saleBoxId: 0,
        cambio: this.data_venta.cambio,
        efectivocapturado:  this.data_venta.montoingresado
      };

      this.loading = true;
      ApiService.registrarVenta(body)
        .then((res) => {
          this.result_venta = res.data;
          this.dialog = true;
          this.loading = false;
          sessionStorage.removeItem('orden');
          sessionStorage.removeItem('datosVenta');
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    cerrarDialog() {
      this.dialog = false;
      this.$bus.$emit("limpiarVenta", 1);
      this.$router.push("/menu/venta");
      location.reload();
    },
    imprimir() {
      let imprimir = "";
      imprimir = document.getElementById("printMe");
      var ventana = "";
      let tituloImpresion = this.result_venta.serial_sale;

      ventana = window.open("", "PRINT", "height=400,width=600");
      ventana.document.write("<html><head><title>" + tituloImpresion + "</title>");
      ventana.document.write('<link rel="stylesheet" href="/css/ticketVenta.css">');
      ventana.document.write(`<meta charset="UTF-8" /> <meta http-equiv="X-UA-Compatible" content="IE=edge" /> <meta name="viewport" content="width=device-width, initial-scale=1.0" />`);
      ventana.document.write("</head><body>");
      ventana.document.write(imprimir.innerHTML);
      ventana.document.write("</body></html>");
      ventana.document.close();
      ventana.focus();
      setTimeout(() => {
        ventana.print();
        ventana.close();
        this.cerrarDialog();
      }, 2000);
    },
  },
};
</script>

<style scoped>
.margin {
  margin-top: 4px;
}

.sale-pv-container {
  display: flex;
  flex-direction: column;
}

.item-sale {
  padding: 2px 0 2px 0;
}
</style>
